const KPSearch = {

    drawer: null,
    overlay: null,
    input: null,
    results: null,

    timer: null,

    init() {

        this.drawer = document.getElementById("KPSearchDrawer");
        this.overlay = document.getElementById("KPSearchOverlay");
        this.input = document.getElementById("KPSearchInput");
        this.results = document.getElementById("KPSearchResults");

        if (!this.drawer) return;

        this.bindEvents();

    },

    bindEvents() {

        const openButton = document.querySelector(".kp-search-btn");

        const closeButton = document.getElementById("KPSearchClose");

        if (openButton) {

            openButton.addEventListener("click", () => {

                this.open();

            });

        }

        if (closeButton) {

            closeButton.addEventListener("click", () => {

                this.close();

            });

        }

        if (this.overlay) {

            this.overlay.addEventListener("click", () => {

                this.close();

            });

        }

        document.addEventListener("keydown", (event) => {

            if (event.key === "Escape") {

                this.close();

            }

        });
                this.input.addEventListener("input", () => {

            clearTimeout(this.timer);

            this.timer = setTimeout(() => {

                this.search(this.input.value.trim());

            }, 250);

        });

    },

    open() {

        this.drawer.classList.add("is-open");

        this.overlay.classList.add("is-open");

        this.drawer.setAttribute("aria-hidden", "false");

        document.body.style.overflow = "hidden";

        this.input.focus();

    },

    close() {

        this.drawer.classList.remove("is-open");

        this.overlay.classList.remove("is-open");

        this.drawer.setAttribute("aria-hidden", "true");

        document.body.style.overflow = "";

        this.input.value = "";

        this.results.innerHTML = `

<div class="kp-search-placeholder">

    Empieza a escribir para buscar productos.

</div>

`;

    },

        async search(query) {

        if (!query) {

            this.results.innerHTML = `

<div class="kp-search-placeholder">

    Empieza a escribir para buscar productos.

</div>

`;

            return;

        }

        this.results.innerHTML = `

<div class="kp-search-loading">

    Buscando...

</div>

`;

        try {

            const response = await fetch(

                `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`

            );

            const data = await response.json();

            this.renderResults(

                data.resources.results.products || []

            );

        }

        catch (error) {

            console.error("KP Search:", error);

        }

    },

    formatMoney(price) {

        return new Intl.NumberFormat("es-CO", {

            style: "currency",

            currency: "COP",

            maximumFractionDigits: 0

        }).format(price);

    },
        renderResults(products) {

        if (!products.length) {

            this.results.innerHTML = `

<div class="kp-search-empty">

    No encontramos productos.

</div>

`;

            return;

        }

        this.results.innerHTML = products.map(product => `

<a
    href="${product.url}"
    class="kp-search-product">

    <div class="kp-search-product-image">

        <img
            src="${product.featured_image.url}"
            alt="${product.title}">

    </div>

    <div class="kp-search-product-info">

        <div class="kp-search-product-title">

            ${product.title}

        </div>

        <div class="kp-search-product-price">

            ${this.formatMoney(product.price)}

        </div>

    </div>

</a>

`).join("");

    }

};
document.addEventListener("DOMContentLoaded", function () {

    KPSearch.init();

});
